<template>
  <v-container class="my-4">

    <v-row>
      <v-col cols="12" class="text-center">
        <div class="text-h2">
          <span class="text-success">123</span>
          <span>PSY</span>
        </div>
        <!-- <v-img src="images/logo.png" max-width="200" class="mx-auto"></v-img> -->
        <div class="font-weight-light">{{ $t('motto') }}</div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card :min-height="'200px'" class="mt-2">
          <v-card-title>{{ $t('welcome.welcome_to_123psy') }}</v-card-title>
          <v-card-subtitle>{{ $t('welcome.your_online_psychological_assessment_platform') }}</v-card-subtitle>
          <v-card-text>
            <ul class="ml-4">
              <li>{{ $t('welcome.create_and_manage_client_evaluations') }}</li>
              <li>{{ $t('welcome.access_validated_assessment_scales') }}</li>
              <li>{{ $t('welcome.track_client_progress_over_time') }}</li>
              <li>{{ $t('welcome.secure_confidential_and_easy_to_use') }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card :min-height="'200px'" class="mt-2">
          <v-card-title>{{ $t('welcome.what_you_can_do_with_it') }}</v-card-title>
          <v-card-text>
            <ul class="ml-4">
              <li>{{ $t('welcome.send_evaluations_links_directly_to_clients') }}</li>
              <li>{{ $t('welcome.automatic_scoring_and_interpretation_so_you_can_focus_more_on_therapy') }}</li>
              <li>{{ $t('welcome.generate_professional_reports') }}</li>
              <li>{{ $t('welcome.monitor_client_progress_with_visual_charts') }}</li>
              <li>{{ $t('welcome.use_professional_standardized_assessments') }}</li>
            </ul>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col col="12" class="text-center">
          <v-btn v-if="isLoggedIn" color="success" to="/login">{{ $t('welcome.access_account') }}</v-btn>
          <v-btn v-else color="success" to="/login">{{ $t('welcome.sign_up') }}</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col col="12" class="text-center">
        <span class="text-caption text-grey-lighten-1">
          {{appTag}} · {{ appVersion }} · {{ appVersionDate }}
        </span>
      </v-col>
    </v-row>

  </v-container>



</template>

<script>
import appVersionMixin from '@/mixins/appVersionMixin'

export default {
  name: 'WelcomeView',
  mixins: [appVersionMixin],
  data() {
    return {
    }
  },
  computed:{
    isLoggedIn() {
      return this.store.isLoggedIn;
    },
  }
}
</script>

<style scoped>
.welcome {
  text-align: center;
  padding: 2rem;
}
</style>